import type { GetTermsTermsType } from './getTermsTermsType';
import type { GetTermsLanguage } from './getTermsLanguage';

export type GetTermsParams = {
/**
 * 조회할 약관 타입 (생략 시 전체 약관 조회)
 */
termsType?: GetTermsTermsType;
/**
 * 언어 코드
 */
language?: GetTermsLanguage;
};
